import { render, staticRenderFns } from "./siteFooter.vue?vue&type=template&id=2fead6ea&scoped=true"
import script from "./siteFooter.vue?vue&type=script&lang=js"
export * from "./siteFooter.vue?vue&type=script&lang=js"
import style0 from "./siteFooter.vue?vue&type=style&index=0&id=2fead6ea&prod&lang=scss&scoped=true"
import style1 from "./siteFooter.vue?vue&type=style&index=1&id=2fead6ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fead6ea",
  null
  
)

export default component.exports